import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class VideoEmailYTManagerAPI {

    constructor(http) {
        this.http = http;
    }

    save(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/youtubeManager/videoEmail/save', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/youtubeManager/videoEmail/getById/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getStatsById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoEmail/getStats/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("tracking_details"))
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getParams(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/youtubeManager/videoEmail/getParams')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("params"))
                         successCallback(json);
                        //successCallback(json.params);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getAdminList(account_owner_user_id, include_removed, search, whitelabel_id, page, limit, sortBy, sortDir, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;
        queryString += "&sortBy=" + sortBy;
        queryString += "&sortDir=" + sortDir;
        queryString += "&includeRemoved=" + include_removed;

        if(search)
            queryString += "&search=" + search;

        if(whitelabel_id)
            queryString += "&whitelabel_id=" + whitelabel_id;

        this.http.get('api/youtubeManager/videoEmail/getList' + (account_owner_user_id == null ? "" : "/" + account_owner_user_id) + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("videos"))
                        successCallback(json.videos);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    reproduce(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/youtubeManager/videoEmail/reproduce', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    updateVideoPlayedNotification(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/videoEmail/updateVideoPlayedNotification', formData)
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                if(json.hasOwnProperty("videos"))
                        successCallback(json.video);

            }
            else {
                errorCallback();
            }
        });

    }

    sendVideoEmail(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {

            x.withHeader("Authorization", token);
        });

        this.http.post('api/youtubeManager/videoEmail/sendVideoEmail', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }


    deleteVideo(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {

            x.withHeader("Authorization", token);
        });

        this.http.post('api/youtubeManager/videoEmail/deleteVideo', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getVideo(id,token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/youtubeManager/videoEmail/getUserVideo/' + id + '?Authorization=' + token + '&t=' + new Date())
            .then(data => {
                if(data.responseType== "json") {
                if (data.isSuccess) {
                    console.log("aws url api result",data);

                    var json = JSON.parse(data.response);
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            }
            else {
            successCallback(data);
            }

            });

    }

    getFileList(id, token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {

            x.withHeader("Authorization", token);
        });

        this.http.get('api/youtubeManager/videoEmail/getFileList/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("bucket")) {
                        successCallback(json);
                    }

                    else if(json.hasOwnProperty("files")) {
                        successCallback(json.files);
                    }

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });
    }

    deleteCustomPreview(videoId, successCallback, errorCallback) {



        this.http.post('api/videoEmail/deleteCustomPreview/' + videoId)
            .then(data => {

                if (data.isSuccess) {


                    successCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }


    setFrame(data, customFrame, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));

        if (customFrame != null)
            formData.append('frame', customFrame);


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/youtubeManager/videoEmail/setFrame', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });
    }
    getContacts(token, data, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });
        this.http.post('api/contact/getList', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);
                    if(json.hasOwnProperty("contacts"))
                        successCallback(json.contacts);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
}
